import React, { Component } from 'react';
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayDiscussion7 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));

  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
            <p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Course <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Discussion 7</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>The Compromise of 1850 in Georgia led to the unrest evoked by the Constitutional issue between the federal law and the initial conventions and the political matter of the Democrats’ dominance.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required question “What constitutional and political issues in the 1850s indicated unrest for Georgia as a member of the United States?” explicitly. </li>
                  <li>Structure: Introduction contains an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>The Constitutional issue in Georgia in 1850s was brought by the Compromise of 1850 that questioned adhering to the conventions under which the Union was initially formed. The document was designed to resolve the issue of slavery in the territories acquired after the Mexican War. However, the state reacted to it with the Georgia Platform, proclaiming that no further encroachment of the federal government on the slavery matters in the Southern states would be tolerated. One of the document’s key points was that the state remained in the Union as long as its rights for slaveholding were protected by the Constitution (Saye 210). Thus, Georgia perceived the Compromise of 1850 as a significant violation of the Constitution.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: the instructions require to discuss Constitutional and political issues. Therefore, the essay contains two body paragraphs devoted to each of the required aspects. </li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>One of the major political issues that contributed to Georgia’s opposing the Union was the ascendancy of the Democratic Party. In the preceding decade the political arena was volatile and the power shifted from the Whig to the Democrats and vice versa. However, the Compromise of 1850 has facilitated the establishment of the Constitutional Union Party comprised of both primary political forces. Having accomplished their goal to make the Union accept the Georgia Platform, “in 1852 the party was disbanded” (Saye 212). Since then, the Democratic Party became the major Georgian political force with other parties having no significant influence (Saye 214). Such an uneven distribution of powers consequently led to the full control exclusively conducted by the Democratic Party.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with cited information from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a topic sentence and finishes with a transition sentence.</li>
                  {/* <li> Conclusion restates the thesis statement and the arguments discussed in the main body.</li>
                  <li> It includes no in-text citations and no new information.</li> */}
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>In conclusion, the constitutional and political issues in Georgia brought by the Compromise of 1850 reshaped the political arena to primarily Democratic, facilitating unrest for Georgia as a US member.</p>
              <div className={styles.comment}>
                <ul>
                  {/* <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with cited information from the outside source.</li> */}
                  <li> Conclusion restates the thesis statement and the arguments discussed in the main body. It includes no in-text citations and no new information.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a topic sentence and finishes with a transition sentence.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">
            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>Saye, Albert Berry. <i>A Constitutional History Of Georgia</i>, 1732-1945. University Of Georgia </div>
              <p>Press, 2011.</p>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style. </li>
                  <li>In case the paper contains more than one source, the list should be alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayDiscussion7);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayDiscussion7.js